export default __webpack_public_path__ + "static/assign-agent-details-dark-790faef9b57455a80557da9a597ca75a.png";